import "@pjs/theming/dist/theme.css";
import "@pjs/a11y/dist/styles/utilities.css";
import { injectCss } from "../../../../../../../node_modules/@pebblepad/pebblepack/runtime/InjectCss.runtime.js";
injectCss(`.fbk-capability-approval-view__history-icon{fill:var(--colour-icon-fill-info);width:2rem;height:2rem;margin-left:var(--layout-margin-between-content);display:block}`);